module.exports = __webpack_public_path__ + "static/media/store-no-connection.9d88499a.svg";